// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"MobileAppPage","383":"SalePage"}[chunkId] || chunkId) + "." + {"163":"cf0686b6","383":"0ff9a15d","793":"1618cf0c"}[chunkId] + ".js";
};